import { render, staticRenderFns } from "./newDetailRecommendItem.vue?vue&type=template&id=e4a48d7e&scoped=true&"
import script from "./newDetailRecommendItem.vue?vue&type=script&lang=js&"
export * from "./newDetailRecommendItem.vue?vue&type=script&lang=js&"
import style0 from "./newDetailRecommendItem.vue?vue&type=style&index=0&id=e4a48d7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a48d7e",
  null
  
)

export default component.exports